<template>
  <div class="product-details-features" v-if="features.length > 0">
    <div class="product-details-features__title">{{ $t('FEATURES') }}</div>
    <div class="product-details-features__features">
      <div
        class="product-details-features__features__feature"
        v-for="feature in features"
      >
        <nuxt-img
          v-if="!!(feature.icon && feature.icon.desktop && feature.icon.mobile)"
          :src="isDesktop ? feature.icon.desktop : feature.icon.mobile"
          height="40"
          width="40"
          class="product-details-features__features__feature__icon"
        />
        <div class="product-details-features__features__feature__content">
          <div
            v-if="feature.title"
            class="product-details-features__features__feature__content__title"
          >
            {{ feature.title }}
          </div>
          <div
            v-if="feature.text"
            class="product-details-features__features__feature__content__text"
          >
            {{ feature.text }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { useWindow } from '~/composables';

export default defineComponent({
  name: 'ProductDetailsFeatures',
  components: {},
  props: {
    product: {
      type: Object,
      default: () => null,
    },
    features: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const { isDesktop } = useWindow();

    return {
      isDesktop,
    };
  },
});
</script>

<style lang="scss" scoped>
.product-details-features {
  max-width: 37.5rem;
  &__title {
    @include label-s;
    padding-bottom: 0.9375rem;
  }
  &__features {
    &__feature {
      &:not(:last-child) {
        padding-bottom: 1.5625rem;
      }
      &__icon {
        position: absolute;
        height: 2.5rem;
        width: 2.5rem;
      }
      &__content {
        margin-left: 3rem;
        @include paragraph-m;
        &__title {
          padding: 0.625rem 0 0.625rem;
        }
        &__text {
          color: var(--c-dark-gray);
        }
      }
    }
  }
}
</style>
